// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Generic$ApiTypes from "./utils/Generic.bs.js";
import * as ThemeId$ApiTypes from "./ThemeId.bs.js";
import * as ThemeDecoders$ApiTypes from "./ThemeDecoders.bs.js";

function toJson(c) {
  return Curry._1(Generic$ApiTypes.Encode.string, c);
}

var fromJson = ThemeDecoders$ApiTypes.Color.fromJson;

var Color = {
  toJson: toJson,
  fromJson: fromJson
};

function toJson$1(px) {
  return Curry._1(Generic$ApiTypes.Encode.string, px);
}

var fromJson$1 = ThemeDecoders$ApiTypes.Px.fromJson;

var Px = {
  toJson: toJson$1,
  fromJson: fromJson$1
};

function toJson$2(fontFamily) {
  return Generic$ApiTypes.Encode.nullable(fontFamily, Generic$ApiTypes.Encode.string);
}

var fromJson$2 = ThemeDecoders$ApiTypes.Font.FontFamily.fromJson;

var FontFamily = {
  toJson: toJson$2,
  fromJson: fromJson$2
};

function toJson$3(fontWeight) {
  return Generic$ApiTypes.Encode.simpleVariant([
              [
                "WeightAuto",
                /* WeightAuto */0
              ],
              [
                "WeightThin",
                /* WeightThin */1
              ],
              [
                "WeightLight",
                /* WeightLight */2
              ],
              [
                "WeightNormal",
                /* WeightNormal */3
              ],
              [
                "WeightMedium",
                /* WeightMedium */4
              ],
              [
                "WeightSemiBold",
                /* WeightSemiBold */5
              ],
              [
                "WeightBold",
                /* WeightBold */6
              ]
            ], fontWeight);
}

var fromJson$3 = ThemeDecoders$ApiTypes.Font.FontWeight.fromJson;

var FontWeight = {
  toJson: toJson$3,
  fromJson: fromJson$3
};

function toJson$4(font) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "fontFamily",
                toJson$2(font.fontFamily)
              ],
              [
                "fontSizeScale",
                Curry._1(Generic$ApiTypes.Encode.$$float, font.fontSizeScale)
              ],
              [
                "fontWeight",
                toJson$3(font.fontWeight)
              ]
            ]);
}

var fromJson$4 = ThemeDecoders$ApiTypes.Font.fromJson;

var Font = {
  FontFamily: FontFamily,
  FontWeight: FontWeight,
  toJson: toJson$4,
  fromJson: fromJson$4
};

function toJson$5(art) {
  if (typeof art === "number") {
    return Generic$ApiTypes.Encode.simpleVariant([[
                  "NoArt",
                  /* NoArt */0
                ]], /* NoArt */0);
  } else if (art.TAG === /* GradientArt */0) {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(art._0, "GradientArt", Generic$ApiTypes.Encode.string);
  } else {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(art._0, "ImageArt", Generic$ApiTypes.Encode.string);
  }
}

var fromJson$5 = ThemeDecoders$ApiTypes.Art.fromJson;

var Art = {
  toJson: toJson$5,
  fromJson: fromJson$5
};

function toJson$6(param) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "themeId",
                Curry._1(ThemeId$ApiTypes.toJson, param.themeId)
              ],
              [
                "themeName",
                Curry._1(Generic$ApiTypes.Encode.string, param.themeName)
              ],
              [
                "themeCreatedAt",
                Curry._1(Generic$ApiTypes.Encode.$$float, param.themeCreatedAt)
              ],
              [
                "themeUpdatedAt",
                Curry._1(Generic$ApiTypes.Encode.$$float, param.themeUpdatedAt)
              ],
              [
                "primaryColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.primaryColor)
              ],
              [
                "secondaryColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.secondaryColor)
              ],
              [
                "tertiaryColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.tertiaryColor)
              ],
              [
                "accentColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.accentColor)
              ],
              [
                "backgroundColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.backgroundColor)
              ],
              [
                "backgroundArt",
                toJson$5(param.backgroundArt)
              ],
              [
                "placeholderColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.placeholderColor)
              ],
              [
                "productPromoBackgroundColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.productPromoBackgroundColor)
              ],
              [
                "productPromoLabelColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.productPromoLabelColor)
              ],
              [
                "productPriceDiscountBackgroundColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.productPriceDiscountBackgroundColor)
              ],
              [
                "productPriceDiscountLabelColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.productPriceDiscountLabelColor)
              ],
              [
                "drawerLabelColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.drawerLabelColor)
              ],
              [
                "drawerBackgroundColor",
                Curry._1(Generic$ApiTypes.Encode.string, param.drawerBackgroundColor)
              ],
              [
                "headingFont",
                toJson$4(param.headingFont)
              ],
              [
                "bodyFont",
                toJson$4(param.bodyFont)
              ],
              [
                "buttonFont",
                toJson$4(param.buttonFont)
              ],
              [
                "roundedEdges",
                Curry._1(Generic$ApiTypes.Encode.string, param.roundedEdges)
              ],
              [
                "rowGutter",
                Curry._1(Generic$ApiTypes.Encode.string, param.rowGutter)
              ],
              [
                "columnGutter",
                Curry._1(Generic$ApiTypes.Encode.string, param.columnGutter)
              ],
              [
                "sectionVerticalPadding",
                Curry._1(Generic$ApiTypes.Encode.string, param.sectionVerticalPadding)
              ],
              [
                "sectionPaddingTop",
                Generic$ApiTypes.Encode.nullable(param.sectionPaddingTop, toJson$1)
              ],
              [
                "sectionPaddingBottom",
                Generic$ApiTypes.Encode.nullable(param.sectionPaddingBottom, toJson$1)
              ]
            ]);
}

function reference_toJson(v) {
  if (v) {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(v._0, "LinkedTheme", ThemeId$ApiTypes.toJson);
  } else {
    return Generic$ApiTypes.Encode.simpleVariant([[
                  "LegacyTheme",
                  /* LegacyTheme */0
                ]], /* LegacyTheme */0);
  }
}

var fromJson$6 = ThemeDecoders$ApiTypes.fromJson;

var reference_fromJson = ThemeDecoders$ApiTypes.reference_fromJson;

export {
  Color ,
  Px ,
  Font ,
  Art ,
  toJson$6 as toJson,
  fromJson$6 as fromJson,
  reference_toJson ,
  reference_fromJson ,
}
/* Generic-ApiTypes Not a pure module */
